export default {
    global: {
        close: 'Chiudi',
        save: 'Salva',
        continue : 'Continua',
        confirmAndSend: 'Conferma e invia',
        mandatory_field: 'Questo campo è obbligatorio',
        checkbox_mandatory : 'Questa casella di controllo è obbligatoria',
        cancel: 'Annulla',
        ok: 'Ok',
        yes: 'Si',
        no: 'NO',
        post_success: 'Dati inviati correttamente',
        code : 'CODICE:'
    },
    menu: {
        main_menu: 'Menu principale',
        lmra: 'Apri/Chiudi LMRA',
        report_incident: "Segnala un incidente",
        report_near_incident: "Segnala un quasi incidente",
        risk_analysis: 'Analisi del rischio',
        corona_analysis: 'Analisi Corona',
        scan_qr: "Scansiona TAG/QR-CODE",
        process_issue: "Segnala un problema relativo al processo",
        checklist: "Visualizza lista di controllo",
        log_in: "Accedi",
        log_out: "Esci",
        emergency_numbers: "Numeri di emergenza",
        project_documentation : "Documentazione del progetto"
    },
    default_lrma: {
        what_label: 'Ho capito cosa fare?',
        how_label: 'So come farlo?',
        risks_label: 'Riconosco i pericoli e i rischi?',
        control_label: 'Posso controllarlo?',
        default_pbm_label: 'Ho il DPI corretto?',
        default_pbm_question: 'Ho il DPI corretto?|1',
        lmra_job_state_positive: 'Ok per iniziare il lavoro, rivedremo l\'LMRA quando si verificheranno cambiamenti',
        lmra_job_state_negative: 'Non stiamo ancora iniziando a lavorare.',
    },
    static_three_state_lmra: {
        getting_data_title: "È in fase di download l'ultima versione.",
        could_not_load_newest_list_title: "Attenzione",
        could_not_load_newest_list: 'Qualcosa è andato storto durante il recupero dell\'elenco più recente. Verrà visualizzata una versione salvata precedente dell\'elenco in modo da poter continuare. Se il problema persiste, è meglio informare una persona responsabile.',
    },
    private_location: {
        title: 'Sei in un luogo privato?',
        body: 'I luoghi privati sono luoghi esterni ai luoghi di lavoro'
    },
    remarks: {
        remarksDialogTitle: 'Osservazioni?',
        remarksDialogPlaceholder: 'Digita qui i tuoi commenti',
    },
    start_stop_screen: {
        start_work_btn: "inizia a lavorare",
        stop_work_btn: "smetti di lavorare",
    },
    work_report: {
        title: "Rapporto di lavoro",
        placeholder: "Digita qui il tuo rapporto di lavoro",
        skip_work_report: "Salta",
        buildingListTitle: "Stiamo creando il modulo del rapporto di lavoro, l'operazione non dovrebbe richiedere troppo tempo.",
        criticalErrorTitle: 'Errore:',
        criticalErrorBody: 'Qualcosa è andato storto durante la creazione del modulo del rapporto di lavoro! Fornisci al tuo manager il codice di errore riportato di seguito:',
    },
    incident_report: {
        title: "Segnala incidente",
        placeholder: "Cosa è successo?",
    },
    oeps_report: {
        title: "Segnalazione di un incidente",
        placeholders: {
            machine: 'Quale macchina?',
            who: "Chi era coinvolto?",
            what: "Cosa è successo?",
            how: 'Come è successo/come è successo?',
            stop_card: 'Seleziona Stopcard',
            location: 'Seleziona posizione',
            department: 'Seleziona dipartimento'
        },
        external_employee: "È un dipendente esterno",
        when_text_label: 'Quando è successo?',
        change_date_time_btn: 'Cambia data/ora'
    },
    risk_analysis: {
        title: {
            risk_default: "Analisi del rischio",
            risk_default_sub_title: '',
            corona: "Analisi della corona",
            corona_sub_title: 'Indica qui sotto le tue condizioni di lavoro e scopri come lavorare in sicurezza.'
        },
        lists: {
            risk_default: {
                gravity: {
                    label: 'Gravità',
                    gravity_01: 'minore, infortunio senza assenteismo',
                    gravity_02: 'importante, infortuni e assenteismo',
                    gravity_07: 'invalidità grave e permanente/condizioni croniche con inabilità (parziale) al lavoro',
                    gravity_15: 'molto grave, 1 morto (acuto a lungo termine)',
                    gravity_40: 'disastro, morti multiple'
                },
                probability: {
                    label: "Probabilità",
                    probability_0_1: 'quasi impossibile da immaginare',
                    probability_0_2: 'praticamente impossibile',
                    probability_0_5: 'immaginabile, ma improbabile',
                    probability_01: 'improbabile, caso limite',
                    probability_03: 'insolito, ma possibile',
                    probability_06: 'abbastanza possibile',
                    probability_10: 'previsto'
                },
                exposure: {
                    label: 'Esposizione',
                    exposure_0_5: 'molto raro (1 volta all\'anno)',
                    exposure_01: 'raramente (ogni anno)',
                    exposure_02: 'a volte (mensilmente)',
                    exposure_03: 'occasionalmente (settimanale)',
                    exposure_06: 'regolarmente (tutti i giorni)',
                    exposure_10: 'costantemente',
                },
            },
            corona: {
                distance: {
                    label: 'Distanza prevista tra me e gli altri:',
                    distance_01: 'D > 8 m',
                    distance_02: '6 m < D < 8 m',
                    distance_07: '2 m < D < 6 m',
                    distance_15: '1,5 m < D < 2 m',
                    distance_40: '1 m < D < 1,5 m',
                    distance_100: 'D < 1 m'
                },
                probability: {
                    label: 'Noto che altri...',
                    probability_0_1: "indossa una maschera FFP2 + occhiali + indumenti protettivi",
                    probability_0_2: 'indossa una maschera FFP2 + occhiali',
                    probability_0_5: 'indossa una maschera o una visiera',
                    probability_01: 'rispetta sicuramente le linee guida Corona',
                    probability_03: 'forse rispetta le linee guida Corona',
                    probability_06: 'violare alcune linee guida Corona',
                    probability_10: "Violazione di più linee guida Corona"
                },
                exposure: {
                    label: 'Possibilità di un contatto più stretto del previsto:',
                    exposure_0_5: "Molto improbabile",
                    exposure_01: 'Quando diverse cose vanno storte',
                    exposure_02: 'Insolito, se certe cose vanno storte',
                    exposure_03: 'Forse, le probabilità non sono così grandi',
                    exposure_06: 'Assolutamente possibile, ragionevole possibilità',
                    exposure_10: 'Prevedibile, quasi certamente',
                },
            },
        },
        results: {
            risk_default: {
                kinneyCode1: 'nessuno',
                kinneyCode2: 'attenzione richiesta',
                kinneyCode3: 'le misure necessarie possono essere pianificate',
                kinneyCode4: 'miglioramento immediato',
                kinneyCode5: 'smetti di funzionare'
            },
            corona: {
                kinneyCode1: 'Rischio accettabile: non sono necessarie misure protettive aggiuntive',
                kinneyCode2: 'Possibile rischio: richiede attenzione',
                kinneyCode3: 'Grande rischio: adottare misure protettive',
                kinneyCode4: "Rischio elevato: adottare misure di protezione maggiori",
                kinneyCode5: "Rischio molto elevato: provare a modificare l'attività, se impossibile adottare le massime misure di protezione"
            },
        },
        supportive_texts: {
            risk_default: {
                supportiveText1: '',
                supportiveText2: '',
                supportiveText3: '',
                supportiveText4: '',
                supportiveText5: ''
            },
            corona: {
                supportiveText1: "Conosco e rispetto le linee guida Corona che si applicano nel mio ambiente di lavoro.",
                supportiveText2: 'Conosco e rispetto le linee guida Corona applicabili. Chiedo espressamente alle persone nel mio ambiente di lavoro di rispettare anche le linee guida Corona. Non sono necessarie ulteriori misure protettive aggiuntive.',
                supportiveText3: 'Mi sono disinfettato le mani all\'inizio e alla fine dell\'attività. Indosso una visiera o una maschera per la bocca adatta in combinazione con occhiali (di sicurezza). Le persone nel mio ambiente di lavoro devono almeno indossare anche una visiera o una maschera per il naso (preferibilmente insieme ad occhiali protettivi). So come utilizzare correttamente questi dispositivi di protezione collettiva e come applicarli nella pratica. Conosco e rispetto le Linee guida Corona applicabili e chiedo espressamente alle persone nel mio ambiente di lavoro di rispettare anche le Linee guida Corona.',
                supportiveText4: 'Mi sono disinfettato le mani all\'inizio e alla fine dell\'attività e dopo ogni tocco non sicuro. Indosso una maschera protettiva per bocca e naso (preferibilmente una maschera di protezione respiratoria FFP2) in combinazione con una visiera o occhiali protettivi. So come utilizzare correttamente questi dispositivi di protezione individuale (DPI) e come applicarli nella pratica. Conosco le linee guida Corona che si applicano nell\'ambiente di lavoro e ovviamente continuo a rispettarle. Chiedo anche alle persone nel mio ambiente di lavoro di adottare le misure di sicurezza necessarie e di osservare le linee guida Corona.',
                supportiveText5: 'Valuto innanzitutto se l\'attività può essere svolta in altro modo senza contatto diretto con altre persone. Se ciò non fosse possibile, adotterò tutte le misure di sicurezza possibili. Mi sono disinfettato le mani all\'inizio e alla fine dell\'attività. Indosso guanti protettivi. Indosso una maschera di protezione respiratoria (almeno FFP2) in combinazione con una visiera o occhiali protettivi e indumenti protettivi. So come utilizzare correttamente questi dispositivi di protezione individuale (DPI) e come applicarli nella pratica. Conosco le linee guida Corona che si applicano nell\'ambiente di lavoro e ovviamente continuo a rispettarle. Chiedo alle persone nel mio ambiente di lavoro di adottare anche le misure di sicurezza necessarie e di osservare attentamente le linee guida Corona.'
            }
        },
        leave_warning: {
            risk_default: {
                title: 'Attenzione',
                body: 'Stai per chiudere questa finestra senza inviare l\'attuale rapporto di analisi dei rischi. Sei sicuro di voler lasciare la pagina?'
            },
            corona: {
                title: 'Attenzione',
                body: 'Stai per chiudere questa finestra senza inviare l\'attuale rapporto di analisi Corona. Sei sicuro di voler lasciare la pagina?'
            }
        },
        report_title: 'Rapporto di analisi',
        placeholder_report: 'Descrivere/chiarire la situazione'
    },
    process_issue: {
        title: "Segnala un problema relativo al processo",
        placeholders: {
            issue_type_select: 'Seleziona il tipo di problema',
            failure_detail: 'Seleziona i dettagli del problema',
            who: 'Chi era coinvolto?',
            description: 'Descrivi il problema',
            cnf: 'CNF?',
            comment: 'Osservazioni aggiuntive/commenti',
            other: 'Altro'
        }
    },
    checklist: {
        getting_data_title: "L'ultima checklist è stata raccolta."
    },
    data_transfer: {
        post_busy: 'Attendere, i dati vengono inviati.',
        post_success: "Dati inviati correttamente."
    },
    gdpr_disclaimer: {
        title: 'Proposta GDPR:',
        body: 'Inviando un elemento dell\'applicazione lmra-first, i seguenti elementi verranno memorizzati nel database: posizione attuale (GPS - coordinate (dopo la conferma)) e l\'ora esatta (e solo in quel momento). Nessuno di questi articoli sarà venduto ad altri partiti o organizzazioni. I dati memorizzati verranno utilizzati solo in ordine al progetto e alle relative condizioni di lavoro',
        accept_btn: 'Accetto',
        decline_btn: 'Lasciare l\'app'
    },
    data_notice: {
        button_text: 'Cosa succede con queste informazioni?',
        popup_title: '',
        popup_body: ''
    },
    cap_settings: {
        alert_cn_pid_nf_title: 'Spiacenti, sembra che tu abbia dimenticato qualcosa:',
        alert_cn_pid_nf_body: 'Nome cliente e/o ID progetto non compilati, verificare i valori',
        client_select_placeholder: 'Seleziona un cliente',
        project_select_placeholder: "Seleziona un progetto",
        client_not_in_list_label: 'Cliente non nell\'elenco',
        project_not_in_list_label: 'Progetto non nell\'elenco',
        client_name: 'Nome cliente',
        project_id: "ID progetto",
        project_distance: 'Distanza del progetto',
        project_shift: 'Spostamento del progetto',
        user_initials: 'Le tue iniziali',
        project_tag_code_label: 'Codice TAG del progetto',
        warning: {
            intro: "Ora stai utilizzando l'immissione manuale per",
            reason_server: 'perché non è stato possibile caricare i dati del server!',
            reason_client_not_listed: 'perché il cliente non era nell\'elenco corrente!',
            reason_project_not_listed: 'perché il progetto non era nell\'elenco corrente!',
            dbl_check: 'Ricontrolla tutti i tuoi valori prima di salvare!',
            admin_msg: 'Se questo messaggio continua ad apparire contatta il tuo amministratore e segnalalo!'
        },
        input_errors: {
            no_client_selected: 'Seleziona un cliente',
            no_project_selected: 'Seleziona un progetto',
        },
        loading_cap: 'Caricamento dei dati dal server',
        custom_shifts_labels: {
            open_field : 'Campo aperto'
        },
        rrqrcode:{
            scan_error_invalid_format : {
                title : "Errore di scansione",
                body : "Rilevato formato dati QR non valido"
            },
            error_popup_notice_manual_mode : {
                title : "Qualcosa è andato storto",
                body : "Qualcosa è andato storto durante il caricamento dei dati RRQRCode, passaggio alla modalità manuale"
            }
        }
    },
    tag_code_scanner: {
        global: {
            loading_stream: 'Caricamento dello streaming della telecamera in corso...',
            default_error_button_test : 'Esci'
        },
        overlay_view: {
            title : "Scansiona TAG - Codice",
            info_manual : 'Hai problemi con la scansione? Utilizza l\'input manuale',
            manual_btn : 'Abilita immissione manuale.',
            errors : {
                invalid_tag_title: "CODICE TAG non valido",
                invalid_tag_body: 'Il codice che hai scansionato non è un TAG-CODE valido, scansiona un TAG-CODE valido o passa all\'inserimento manuale.',
                error_btn_txt: "Abilita immissione manuale"
            }
        }
    },
    errors: {
        checklistNotLoaded: 'Qualcosa è andato storto durante il recupero dell\'elenco, riprova più tardi.',
        EmergencyNumbersOverviewNotLoaded: 'Qualcosa è andato storto durante il recupero dell\'elenco, riprova più tardi.',
        missing_critical_resource_title: "Errore durante il caricamento dei dati:",
        missing_critical_resource: 'Una risorsa manca dall\'applicazione. Segnala il codice seguente all\'amministratore.',
        app_corrupt: 'Sembra che la configurazione dell\'applicazione sia danneggiata. Contatta il tuo amministratore.',
        data_save_failed: 'I dati non possono essere inviati, riprova più tardi...',
        camera: {
            NotAllowedError: 'ERRORE: è necessario concedere l\'autorizzazione per l\'accesso alla fotocamera',
            NotFoundError: 'ERRORE: nessuna fotocamera su questo dispositivo',
            NotSupportedError: 'ERRORE: contesto sicuro richiesto (HTTPS, localhost)',
            NotReadableError: 'ERRORE: la fotocamera è già in uso?',
            OverconstrainedError: 'ERRORE: le telecamere installate non sono adatte',
            StreamApiNotSupportedError: 'ERRORE: l\'API Stream non è supportata in questo browser',
        },
        no_internet: 'Oooops... sei Offline, controlla la tua connessione internet!',
        input_validation: {
            char_limit: 'È consentito un massimo di %n caratteri'
        },
        auth0 :{
            unverified_email : {
                error: 'Errore: l\'indirizzo email non è verificato! Controlla le tue email!',
                info : 'Per poter accedere a questa applicazione <b>devi verificare il tuo indirizzo e-mail</b>.<br/><br/>Riceverai <b>riceverai un\'e-mail</b> a breve <b >da |SENDER| </b><br/><br/><i>Per verificare il tuo indirizzo email. Segui le istruzioni nell\'e-mail</i>'
            }
        }
    },
    noDataText: "Dati non disponibili...",
    defaultDynamicQuestion: '{"dynamic_questions":[{"id":null,"question":"Ho i DPI corretti?","correct_answer":"1"}]}',
    auth : {
        emailLabel: 'E-mail',
        passwordLabel : 'Parola d\'ordine',
        rememberMeLabel : "Ricordati di me",
        logInBtn: "Accedi",
        logOutBtn: "Esci",
        verifyMFABtn: "Verifica",
        errorPopupTitle: "Errore",
        confirmIdentify: "Ancora tu?",
        errors :{
            required : "Richiesto",
            invalidEmail: "E-mail non valida",
            unknownError: "Si è verificato un errore sconosciuto"
        },
        registerNewAccountBtn : "Crea un nuovo account.",
        forgotPassword: "Password dimenticata"
    },
    lmraComponent : {
        loadingProjectData : 'Preparazione del modulo LMRA, attendere',
        startWorkQrDialog:{
            title : "Seleziona metodo di avvio:",
            body : "Se è presente il codice QR Riflesso rischio, seleziona il codice QR altrimenti utilizza il metodo di immissione manuale",
            positive_btn : "Codice QR",
            negative_btn : "Metodo manuale"
        },
        errors : {
            unknownError : "Si è verificato un errore sconosciuto",
            noListDataFound: "Errore: NESSUN DATO ELENCO TROVATO!! RITORNO A LMRA PREDEFINITO",
            noDefaultListFound: 'Nessun elenco predefinito disponibile! Utilizzo di LMRA PREDEFINITO!',
        }
    },
    customLmraLists : {
        buildingListTitle: "Creazione del tuo modulo LMRA, non dovrebbe richiedere molto tempo.",
        criticalErrorTitle: 'Errore:',
        criticalErrorBody: 'Qualcosa è andato storto durante la creazione del modulo LMRA! Ora caricheremo l\'LMRA predefinito! fornisci al tuo manager il codice di errore riportato di seguito:',
    },
    workSessions :{
        global : {
            expiredLabel : "Scaduta"
        },
        resumeSessionDialog : {
            titleActiveSession : "Sessione attiva trovata",
            titleActiveSessionExpired : "(Scaduta) Sessione attiva trovata",
        },
        workSessionServiceNaDialog :{
            title : 'SERVIZIO SESSIONE DI LAVORO NON DISPONIBILE',
            body : 'Siamo spiacenti, non siamo in grado di determinare se hai una sessione aperta<br/><br/>' +
                '<b>Il modulo LMRA è bloccato: non è possibile avviare o chiudere una sessione. </b><br/> Tuttavia è ancora possibile inviare rapporti sugli incidenti (fuori dalla sessione)<br/>' +
                'Riceverai una notifica quando il servizio della sessione sarà disponibile<br/><br/>' +
                'Se l\'errore persiste, avvisa il tuo amministratore..'
        },
        lmraLocked : {
            lmraComponentLockedInfo : "Siamo spiacenti: <b>Il modulo LMRA è attualmente bloccato: non puoi avviare o chiudere una sessione. </b>"
        },
        lmraVariants : {
            errors : {
                saving_session : {
                    missing_session_data: 'La risposta del server non contiene dati di sessione',
                    could_not_save_session: 'Impossibile salvare i dati della sessione localmente...',
                    invalid_session_data: 'Dati della sessione non validi, i dati potrebbero essere danneggiati'
                }
            }
        }
    },
    whatsAppGroup : {
        errors : {
            unknown : "Si è verificato un errore sconosciuto",
            notFound : "Nessun codice gruppo trovato."
        }
    },
    emergency_numbers: {
        default_number_btn_txt : "Numero di emergenza predefinito",
        getting_data_title: "Ottenere gli ultimi numeri"
    },
    checklist_components :{
        main_checklist_component : {
            tabs : {
                active_checklist : "Lista di controllo attiva",
                other_checklists : "Altre liste di controllo"
            }
        },
        checklist_detail_component : {
            toolbar:{
                title : "Visualizzazione : "
            },
            warning_message : "Stai visualizzando una lista di controllo che non è la lista attiva corrente. Per visualizzare l'elenco attivo utilizzare la scheda \"Checklist attiva\" in alto"
        }
    },
    version_info : {
        update : {
            version_up_to_date: "La versione è aggiornata",
            version_minor_update: "Versione più recente disponibile (potrebbe non essere disponibile per il tuo tenant)",
            update_required: "Attenzione! Questa app è obsoleta, l'app dovrebbe aggiornarsi automaticamente. Se questo messaggio persiste, contatta l'amministratore."
        }
    },
    risk_reflex_qr_code_scanner : {
        overlay_view : {
            errors : {
                wrong_qr_code_type : {
                    title : "Tipo di codice QR errato",
                    body : "Questo tipo di codice QR non è supportato qui"
                },
                wrong_tenant : {
                    title : "Inquilino sbagliato",
                    body : "Questo codice QR non può essere utilizzato dalla tua azienda"
                },
                invalid_qr_code : {
                    title : "Codice QR non valido",
                    body : "Questo non è un codice QR Risk Reflex valido e non può essere utilizzato"
                },
                invalid_qr_data : {
                    title : "Dati del codice QR non validi",
                    body : "Questo codice QR non può essere tradotto, il codice QR potrebbe essere danneggiato"
                }
            },
            title : "Scansiona il codice QR del riflesso del rischio",
            info_manual : 'Hai problemi con la scansione?" Utilizza l\'input manuale',
            manual_btn: "Passa alla modalità manuale"
        }
    },
    project_documentation: {
        documentation_list : {
            getting_data_title : "Ottenimento della documentazione del progetto dal server.",
            no_documentation_found : "Impossibile trovare la documentazione per questo progetto.",
            errors : {
                could_not_load_documentation : "Si è verificato un problema durante l'ottenimento della documentazione, riprovare più tardi."
            }
        }
    }
}